(() => {
  const dialog = document.querySelector('[data-welcome-reward]');
  if (!dialog) return;

  const storageKey = 'wornpage-welcome-reward-v1';
  const code = dialog.dataset.rewardCode.trim();
  const rewardLabel = dialog.querySelector('[data-reward-code-label]');
  const rewardLink = dialog.querySelector('[data-apply-reward]');
  const rewardReturn = dialog.querySelector('[data-reward-return]');
  const closeButton = dialog.querySelector('[data-reward-close]');
  const game = dialog.querySelector('[data-reward-game]');
  const capture = dialog.querySelector('[data-reward-capture]');
  const success = dialog.querySelector('[data-reward-success]');
  const cards = [...dialog.querySelectorAll('[data-reward-card]')];

  if (rewardLabel) rewardLabel.textContent = code;
  if (rewardLink) rewardLink.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/collections/all');
  if (rewardReturn) rewardReturn.value = location.pathname + location.search;

  const remember = value => {
    if (value !== 'claimed') {
      for (const storage of ['localStorage', 'sessionStorage']) {
        try { if (JSON.parse(window[storage].getItem(storageKey))?.value === 'claimed') return; } catch (error) {}
      }
    }
    const record = JSON.stringify({value, at: Date.now()});
    for (const storage of ['localStorage', 'sessionStorage']) {
      try { window[storage].setItem(storageKey, record); } catch (error) {}
    }
  };
  const wasRecentlyDismissed = () => {
    let readable = false;
    for (const storage of ['localStorage', 'sessionStorage']) {
      try {
        const saved = JSON.parse(window[storage].getItem(storageKey));
        readable = true;
        if (saved?.value === 'claimed') return true;
        if (['shown', 'dismissed'].includes(saved?.value) && Date.now() - saved.at < 86400000) return true;
      } catch (error) {}
    }
    return !readable;
  };

  closeButton?.addEventListener('click', () => {
    remember('dismissed');
    dialog.close();
  });
  dialog.addEventListener('click', event => {
    if (event.target === dialog) {
      remember('dismissed');
      dialog.close();
    }
  });
  dialog.addEventListener('cancel', () => remember('dismissed'));

  cards.forEach(card => {
    card.addEventListener('click', () => {
      if (dialog.dataset.played === 'true') return;
      dialog.dataset.played = 'true';
      cards.forEach(item => item.classList.toggle('is-muted', item !== card));
      card.classList.add('is-revealed');
      window.setTimeout(() => {
        game.hidden = true;
        capture.hidden = false;
        capture.querySelector('input')?.focus({preventScroll:true});
      }, 900);
    });
  });

  if (!success && document.querySelector('.newsletter-form .form-message.success')) {
    remember('claimed');
    return;
  }

  if (success) {
    remember('claimed');
    dialog.showModal();
  } else if (capture && !capture.hidden) {
    dialog.showModal();
  } else if (!wasRecentlyDismissed()) {
    // Wait for seven seconds of visible browsing and a deliberate interaction.
    let visibleMs = 0;
    let lastTick = performance.now();
    let engaged = false;
    let lastAction = 0;
    const initialScroll = window.scrollY;
    const engage = () => { engaged = true; lastAction = performance.now(); };
    const onScroll = () => {
      if (Math.abs(window.scrollY - initialScroll) >= 120) engage();
    };
    const onClick = event => {
      if (!event.isTrusted) return;
      if (event.target.closest('[data-world-control], [data-world-previous], [data-world-next], .world-card, .product-card, .collection-world-nav')) engage();
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('click', onClick);
    document.addEventListener('visibilitychange', () => { lastTick = performance.now(); });
    const timer = window.setInterval(() => {
      const now = performance.now();
      if (!document.hidden) visibleMs += Math.min(now - lastTick, 500);
      lastTick = now;
      if (wasRecentlyDismissed()) { cleanup(); return; }
      if (document.hidden || visibleMs < 7000 || !engaged || now - lastAction < 800) return;
      if (document.querySelector('dialog[open], .drawer.open, .search-panel.open') ||
          document.activeElement?.matches('input, textarea, select')) return;
      cleanup();
      dialog.showModal();
      remember('shown');
    }, 250);
    function cleanup() {
      window.clearInterval(timer);
      window.removeEventListener('scroll', onScroll);
      document.removeEventListener('click', onClick);
    }
  }
})();

